/* eslint-disable linebreak-style */
import { useState, type FC, useEffect } from 'react';
import { Box, Button, Card, CardHeader, CardMedia, Divider, IconButton, Skeleton, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Airfield, defaultAirfield } from '../../models/Airfield';
import ArrowLeftIcon from '../../icons/ArrowLeft';
import { Link as RouterLink } from 'react-router-dom';
import { AirfieldService } from '../../services/AirfieldService';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.css";
import axios from 'axios';
import { PhotoCameraBack } from '@material-ui/icons';
import verifiedShield from '../../images/verified_Shield.png';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';
import CircularProgress from '@mui/material/CircularProgress';






interface AirfieldmapCardProps {
  id: string
}



const AirfieldmapCard: FC<AirfieldmapCardProps> = ({ id }) => {
  const { t } = useTranslation();
  const [photo, setPhoto] = useState<string[]>();
  const [isLoadaing, setIsLoadaing] = useState<boolean>(true);
  const [airfield, setAirfield] = useState<Airfield>(defaultAirfield);

  var airfieldService = new AirfieldService();

  useEffect(() => {
    const getAirfield = async () => {
      var tmpPhoto;
      setIsLoadaing(true);
      if (!(id == null || id == undefined || id == "")) {
        tmpPhoto = await airfieldService.getAirfieldById(id);
        tmpPhoto.firstPhotoUrl = await airfieldService.getAirfieldFirstPhoto(id);
      }
      setIsLoadaing(false);
      setAirfield(tmpPhoto);

    }
    getAirfield();
  }, []);



  return (<>
    {isLoadaing ? <Box sx={{ display: 'flex', flexDirection: 'row' }}><Box sx={{ mt: 1.4, mr: 2, display: 'flex' }}>
      <CircularProgress />
    </Box><Typography sx={{ width: 150 }} color="#000000" variant="body1">{" " + t('LOADING') + "..."}</Typography></Box>
      :
      <Box sx={{ mb: 0, mt: -1, display: 'flex', textAlign: "center", flexDirection: 'column' }}>
        <Typography sx={{}} color="#000000" variant="body1">{airfield.name}</Typography>
        <img src={airfield.firstPhotoUrl}
          style={{
            width: "100%",
            maxHeight: 100,
            objectFit: 'contain',
          }} />
        <Button sx={{ mt: 1 }}
          color="primary"
          component={RouterLink}
          to={`details?airfieldId=${airfield.id}`}
          variant="outlined"
        >
          {<>
            {t('DETAILS')}
            {
              airfield.isRegistred &&
              <Box sx={{ mt: 0.5, ml: 2 }}
                component="img"
                src={verifiedShield}
                height={25}
              />
            }
          </>}
        </Button>
      </Box>
    }
  </>
  )
};

export default AirfieldmapCard;
